import script from './Dialog.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"dialog__button-group"},[(_vm.isCancelVisible)?_c('SdsButton',{attrs:{"variant":"secondary","isBlock":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n            "+_vm._s(_vm.formattedCancelLabel)+"\n        ")]):_vm._e(),_vm._v(" "),_c('SdsButton',{attrs:{"variant":"primary","isBlock":"","isDisabled":_vm.isContinueDisabled},on:{"click":function($event){return _vm.$emit('continue')}}},[_vm._v("\n            "+_vm._s(_vm.formattedContinueLabel)+"\n        ")])],1)],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-9d128342_0", { source: ".dialog__button-group[data-v-9d128342]{display:flex;justify-content:space-between;gap:12px}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-9d128342";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
